import React, {useEffect, useState} from 'react';
import Util from '../Service/util';
import AdminSVG from '../../assets/administrator.png';
import { Link } from 'react-router-dom';
import ProfileImage from './ProfileImage/ProfileImage';
import { ImPencil } from 'react-icons/im';
import { useQuery } from 'react-query';
import Service from '../Service/http';
import { toast } from 'react-toastify';
import Alert from '@mui/material/Alert';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { isValidArray } from '../Utils/UtilityFunctions';

function Admin() {

  const util = new Util();
  const service = new Service();

  let [ profileData , SetProfileDta] = useState()
  let [ open, setOpen ] = useState(false)

  const getExpiringBatches = async () => {
    const response = service.get('api/batches/expiring');
    return response;
  }
  
  const { data: notificationData } = useQuery(['expiringBatches'], getExpiringBatches, {

    onSuccess(json) {
            setOpen(true)
        },
    onError(error) {
      toast.error("Something went wrong");
      console.error(error);
      setOpen(false);
    },
    refetchOnWindowFocus: false
  })

  useEffect(()=>{
    SetProfileDta(util.getUserDetails());
  },[])

 
  return (
  <div className='container text-center text-dark d-flex flex-column justify-content-center border'  style={{minHeight:"80vh",
  backgroundRepeat:'no-repeat',

  fontWeight:"revert-layer",
  // textShadow:"3px 3px #C0C0C0"
   }}>

      { open && isValidArray(notificationData.data) &&
        <Alert 
          severity="info" 
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => setOpen(!open)}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
        {
          notificationData?.data?.map((batch, index) => (
            <span key={batch.batch_name}>
              <strong>"{batch.batch_name}" </strong>
              {index < notificationData.data.length - 1 && ', '} {/* To ensure Comma's are proper */}
            </span>
          ))
        }
          batches are going to expire soon.
        </Alert>
      }
    <h1 className='h1 my-3'>Hello Admin !</h1>
    <div className='container d-flex align-items-center flex-column'>
        <ProfileImage profileData={profileData}/>
        <div className="text-start h4"> {profileData?.name?.toUpperCase()} </div>
        <div className="text-start h4"> {profileData?.email} </div>

    </div>
    <div className='mt-3 w-100 d-flex flex-column justify-content-center align-items-center' style={{cursor: 'pointer'}}>
      <Link to={'/admin'} className='custom-button btn text-center border' style={{color: 'white', width: '300px'}}>
          <img src={AdminSVG} alt='admin' width={30} height={30} color='white' className='mx-3'/>
          <h5 className='text-dark'>Admin Options</h5>
      </Link>
      <Link to={`/coding/profile/${profileData?._id}`} className='custom-button btn text-center border mt-3' style={{color: 'white', width: '300px'}}>
        <ImPencil size={22} color='black' className='mx-3'/>
        <h5 className='text-dark'>Update Profile</h5>
      </Link>
    </div>
  </div>
  );
}

export default Admin;
